// use for generating pseudo unique keys
export default (size = 'small') => {
    let max = 1000
    if (size === 'medium') max = 10000
    if (size === 'large') max = 100000
    return Math.floor(Math.random() * max)
}
